import React, {Component} from 'react'
import {Provider, connect } from 'react-redux'
import  ShippingTypeSelector from '../containers/shipping_type_selector'

import ReduxStore from '../reducers'
const store = ReduxStore()

export default class ShippingSelectorRoot extends Component {
  constructor(props){
    super(props);
  }

  componentWillMount() {
    store.dispatch({type: "NEW_SHIPPING_QUOTES", initialState: this.props });
  }

  render(){
    return (
      <Provider store={store}>
        <ShippingTypeSelector />
      </Provider>
    );
  }
}


